/* Back to top */
$('.carousel-down-button').click(function(){

  $('html, body').animate({
    scrollTop: $('.carousel-down-button').offset().top
  }, 1500);

});

